enum OrderStatus {
  ACTIVE = 'ACTIVE',
  TERMINATED = 'TERMINATED',
  IN_PROGRESS = 'IN_PROGRESS',
  DELETED = 'DELETED',
  FINISHED = 'FINISHED',
  CANCELLED = 'CANCELLED',
  NO_STATUS = 'NO_STATUS'
}

export default OrderStatus;
